<template>
  <div>
    <div>
      <el-form
        :disabled="disable"
        :label-position="labelPosition"
        label-width="155px"
        size="small"
        class="form-div"
      >
        <!-- 选择部分商品时候显示 -->
        <!-- <el-form-item> -->
        <div class="Coupons-part">
          <div class="part-class-right">
            <div class="right-top">
              <div class="CategoryFiltering-conter">
                <!-- 类别编码 -->
                <div class="CategoryFiltering-div" v-if="flag == 3">
                  <div class="CategoryFiltering-div-top">
                    <div class="buttom-flex">
                      <el-button @click="SelectCategory">选择类别</el-button>
                      <el-button @click="CategoryModuleDownload"
                        >模板下载</el-button
                      >
                      <el-upload
                        action="#"
                        class="elUpload"
                        ref="UploadImport"
                        :show-file-list="false"
                        :on-change="
                          SecuritiesUsablegoods.GenreType == '按类别筛选'
                            ? ImportCategory
                            : ImportCategory1
                        "
                        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        :auto-upload="false"
                      >
                        <el-button>批量导入</el-button>
                      </el-upload>
                      <el-button @click="resetSelectCategoryData"
                        >清空表格</el-button
                      >
                    </div>
                  </div>
                  <div class="formClass">
                    <el-table
                      size="mini"
                      border
                      height="21rem"
                      :header-cell-style="{
                        background: '#FCFBF2',
                        color: '#6C6839',
                        'text-align': 'center',
                      }"
                      :cell-style="{ 'text-align': 'center' }"
                      ref="singleTable"
                      :data="searchCategoryFormhy.SelectCategoryData"
                      highlight-current-row
                      style="width: 100%"
                    >
                      <el-table-column
                        type="index"
                        width="50"
                      ></el-table-column>
                      <el-table-column property="categoryID" label="类别">
                      </el-table-column>
                      <el-table-column property="categoryCn" label="类别描述">
                      </el-table-column>
                      <el-table-column width="80px" label="操作">
                        <template slot-scope="scope">
                          <el-button
                            type="text"
                            @click="DeleteCategory(scope.row)"
                            size="mini"
                            >删除</el-button
                          >
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </div>
                <!-- 类别标签 -->

                <div class="CategoryFiltering-div" v-if="flag == 4">
                  <div class="CategoryFiltering-div-top">
                    <div>
                      <el-button @click="SelectCategoryLabel"
                        >选择类别标签</el-button
                      >
                      <el-button @click="resetSelectCategoryLabelData"
                        >清空表格</el-button
                      >
                    </div>
                  </div>
                  <div class="formClass">
                    <el-table
                      size="mini"
                      border
                      height="21rem"
                      :header-cell-style="{
                        background: '#FCFBF2',
                        color: '#6C6839',
                        'text-align': 'center',
                      }"
                      :cell-style="{ 'text-align': 'center' }"
                      ref="singleTable"
                      :data="searchCategoryLabelFormhy.SelectCategoryLabelData"
                      highlight-current-row
                      style="width: 100%"
                    >
                      <el-table-column property="name" type="index" width="50">
                      </el-table-column>
                      <el-table-column property="name" label="标签名">
                        <template slot-scope="scope">
                          <div
                            class="ConponesName"
                            @click="OnclickConponesName(scope.row, true)"
                          >
                            {{ scope.row.lblName }}
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column width="80px" label="操作">
                        <template slot-scope="scope">
                          <el-button
                            type="text"
                            @click="DeleteCategoryLable(scope.row)"
                            size="mini"
                            >删除</el-button
                          >
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </div>

                <!-- 商品编码 -->

                <div class="CategoryFiltering-div" v-if="flag == 1">
                  <div class="CategoryFiltering-div-top">
                    <div class="buttom-flex">
                      <el-button @click="SelectGoods">选择商品</el-button>
                      <el-button @click="GoodsModuleDownload"
                        >模板下载</el-button
                      >
                      <el-upload
                        action="#"
                        class="elUpload"
                        ref="UploadImport"
                        :show-file-list="false"
                        :on-change="
                          SecuritiesUsablegoods.GoodsType == '按商品筛选'
                            ? ImportGoods
                            : ImportGoods1
                        "
                        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        :auto-upload="false"
                      >
                        <el-button>批量导入</el-button>
                      </el-upload>
                      <el-button @click="resetSelectGoodsData"
                        >清空表格</el-button
                      >
                    </div>
                  </div>
                  <div class="formClass">
                    <el-table
                      size="mini"
                      border
                      height="21rem"
                      :header-cell-style="{
                        background: '#FCFBF2',
                        color: '#6C6839',
                        'text-align': 'center',
                      }"
                      :cell-style="{ 'text-align': 'center' }"
                      ref="singleTable"
                      :data="GoodsFormhy.SelectGoodsData"
                      highlight-current-row
                      style="width: 100%"
                    >
                      <el-table-column property="name" type="index" width="50">
                      </el-table-column>
                      <el-table-column property="ProductCode" label="产品编码">
                      </el-table-column>
                      <el-table-column width="80px" label="操作">
                        <template slot-scope="scope">
                          <el-button
                            type="text"
                            @click="DeleteGoods(scope.row)"
                            size="mini"
                            >删除</el-button
                          >
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </div>
                <!-- 商品标签 -->
                <div class="CategoryFiltering-div" v-if="flag == 2">
                  <div class="CategoryFiltering-div-top">
                    <div>
                      <el-button @click="SelectGoodsLable"
                        >选择商品标签</el-button
                      >
                      <el-button @click="resetSelectGoodsLableData"
                        >清空表格</el-button
                      >
                    </div>
                  </div>
                  <div class="formClass">
                    <el-table
                      size="mini"
                      border
                      height="21rem"
                      :header-cell-style="{
                        background: '#FCFBF2',
                        color: '#6C6839',
                        'text-align': 'center',
                      }"
                      :cell-style="{ 'text-align': 'center' }"
                      ref="singleTable"
                      :data="GoodsLableFormhy.SelectGoodsLableData"
                      highlight-current-row
                      style="width: 100%"
                    >
                      <el-table-column property="name" type="index" width="50">
                      </el-table-column>
                      <el-table-column property="lblName" label="标签名">
                        <template slot-scope="scope">
                          <div
                            class="ConponesName"
                            @click="OnclickConponesName(scope.row, false)"
                          >
                            {{ scope.row.lblName }}
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column width="80px" label="操作">
                        <template slot-scope="scope">
                          <el-button
                            type="text"
                            @click="DeleteGoodsLable(scope.row)"
                            size="mini"
                            >删除</el-button
                          >
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- </el-form-item> -->
      </el-form>
    </div>
    <!-- 选择类别 -->
    <div class="SecuritiesCategory">
      <el-dialog
        width="35%"
        append-to-body
        title="现金卷库管理-选择类别"
        :visible.sync="innerVisible"
        :close-on-click-modal="false"
      >
        <div style="margin-top: 10px">
          <el-form size="mini" label-width="180px" ref="">
            <el-form-item label="类别查询">
              <div class="flex-between">
                <el-input v-model="searchCategoryFormhy.search"> </el-input>
                <el-button
                  style="
                    width: 80px;
                    margin-left: 10px;
                    background-color: #f1f1f1;
                    color: #b6b388;
                  "
                  size="small"
                  icon="el-icon-search"
                  @click="categorySearchhy"
                  >查询</el-button
                >
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div style="margin-top: 10px">
          <el-table
            size="small"
            class="table-style"
            height="280px"
            border
            :row-class-name="tableRowClassName"
            :header-cell-style="{
              background: '#FCFBF2',
              color: '#6C6839',
              'text-align': 'center',
            }"
            :cell-style="{ 'text-align': 'center' }"
            ref="CategoryTable1"
            :data="searchCategoryFormhy.CategoryData"
            tooltip-effect="dark"
            v-el-table-infinite-scroll="categoryonTouchTheBottom"
            infinite-scroll-disabled="categoryonLoading"
            v-loading="searchCategoryFormhy.loading"
          >
            <el-table-column width="50" type="index"></el-table-column>
            <el-table-column type="selection" width="50"> </el-table-column>
            <el-table-column prop="categoryID" width="150px" label="类别">
            </el-table-column>
            <el-table-column prop="categoryCn" label="类别描述">
            </el-table-column>
          </el-table>
          <el-alert
            v-if="categoryIsMore"
            title="没有更多数据了!"
            type="warning"
            center
            :closable="false"
          >
          </el-alert>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="Selectedvaluetransfer">确 定</el-button>
          <el-button @click="innerVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 选择类别标签 -->
    <div class="SecuritiesCategory">
      <el-dialog
        append-to-body
        width="30%"
        title="现金卷库管理-选择类别标签"
        :visible.sync="CategoryLabelVisible"
        :close-on-click-modal="false"
      >
        <div style="margin-top: 10px">
          <el-form size="mini" label-width="180px" ref="">
            <el-form-item label="类别标签查询">
              <div class="flex-between">
                <el-input v-model="searchCategoryLabelFormhy.search">
                </el-input>
                <el-button
                  style="
                    width: 80px;
                    margin-left: 10px;
                    background-color: #f1f1f1;
                    color: #b6b388;
                  "
                  size="small"
                  icon="el-icon-search"
                  @click="categorySearchhyLabel"
                  >查询</el-button
                >
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div style="margin-top: 10px">
          <el-table
            size="small"
            class="table-style"
            height="280px"
            border
            :row-class-name="tableRowClassName"
            :header-cell-style="{
              background: '#FCFBF2',
              color: '#6C6839',
              'text-align': 'center',
            }"
            :cell-style="{ 'text-align': 'center' }"
            ref="CategoryLabelTable"
            :data="searchCategoryLabelFormhy.CategoryLabelData"
            tooltip-effect="dark"
            v-el-table-infinite-scroll="categoryLabelTouchTheBottom"
            infinite-scroll-disabled="categoryLabelonLoading"
            v-loading="searchCategoryLabelFormhy.loading"
          >
            <el-table-column width="50" type="index"></el-table-column>
            <el-table-column type="selection" width="50"> </el-table-column>
            <el-table-column prop="lblName" label="标签名"></el-table-column>
          </el-table>
          <el-alert
            v-if="categoryLabelIsMore"
            title="没有更多数据了!"
            type="warning"
            center
            :closable="false"
          >
          </el-alert>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="DetermineCategoryLabel">确 定</el-button>
          <el-button @click="CategoryLabelVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>

    <!-- 选择商品 -->
    <div class="SecuritiesCategory">
      <el-dialog
        append-to-body
        width="30%"
        title="现金卷库管理-选择商品"
        :visible.sync="GoodsVisible"
        :close-on-click-modal="false"
      >
        <div style="margin-top: 10px">
          <el-form size="mini" label-width="180px" ref="">
            <el-form-item label="商品名称查询">
              <div class="flex-between">
                <el-input v-model="GoodsFormhy.search"> </el-input>
                <el-button
                  style="
                    width: 80px;
                    margin-left: 10px;
                    background-color: #f1f1f1;
                    color: #b6b388;
                  "
                  size="small"
                  icon="el-icon-search"
                  @click="SearchGoods"
                  >查询</el-button
                >
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div style="margin-top: 10px">
          <el-table
            size="small"
            class="table-style"
            height="280px"
            border
            :row-class-name="tableRowClassName"
            :header-cell-style="{
              background: '#FCFBF2',
              color: '#6C6839',
              'text-align': 'center',
            }"
            :cell-style="{ 'text-align': 'center' }"
            ref="GoodsRefsTable"
            :data="GoodsFormhy.GoodsData"
            tooltip-effect="dark"
            v-el-table-infinite-scroll="GoodsTouchTheBottom"
            infinite-scroll-disabled="GoodsonLoading"
            v-loading="GoodsFormhy.loading"
          >
            <el-table-column width="50" type="index"></el-table-column>
            <el-table-column type="selection" width="50"> </el-table-column>
            <el-table-column
              prop="ProductName_CN"
              label="商品名"
            ></el-table-column>
          </el-table>
          <el-alert
            v-if="GoodsIsMore"
            title="没有更多数据了!"
            type="warning"
            center
            :closable="false"
          >
          </el-alert>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="DetermineGoods">确 定</el-button>
          <el-button @click="GoodsVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>

    <!-- 选择商品标签 -->
    <div class="SecuritiesCategory">
      <el-dialog
        append-to-body
        width="30%"
        title="现金卷库管理-选择商品标签"
        :visible.sync="GoodsLableVisible"
        :close-on-click-modal="false"
      >
        <div style="margin-top: 10px">
          <el-form size="mini" label-width="180px" ref="">
            <el-form-item label="商品标签查询">
              <div class="flex-between">
                <el-input v-model="GoodsLableFormhy.search"> </el-input>
                <el-button
                  style="
                    width: 80px;
                    margin-left: 10px;
                    background-color: #f1f1f1;
                    color: #b6b388;
                  "
                  size="small"
                  icon="el-icon-search"
                  @click="GoodsSearchhyLabel"
                  >查询</el-button
                >
              </div>
            </el-form-item>
          </el-form>
        </div>

        <div style="margin-top: 10px">
          <!-- 选择商品标签 -->
          <el-table
            size="small"
            class="table-style"
            height="280px"
            border
            :row-class-name="tableRowClassName"
            :header-cell-style="{
              background: '#FCFBF2',
              color: '#6C6839',
              'text-align': 'center',
            }"
            :cell-style="{ 'text-align': 'center' }"
            ref="GoodsLabelTable"
            :data="GoodsLableFormhy.GoodsLableData"
            tooltip-effect="dark"
            v-el-table-infinite-scroll="GoodsLabelTouchTheBottom"
            infinite-scroll-disabled="GoodsLabelonLoading"
            v-loading="GoodsLableFormhy.loading"
          >
            <el-table-column width="50" type="index"></el-table-column>
            <el-table-column type="selection" width="50"> </el-table-column>
            <el-table-column prop="lblName" label="标签名"></el-table-column>
          </el-table>
          <el-alert
            v-if="GoodsLabelIsMore"
            title="没有更多数据了!"
            type="warning"
            center
            :closable="false"
          >
          </el-alert>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="DetermineGoodsLabel">确 定</el-button>
          <el-button @click="GoodsLableVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <el-dialog
      append-to-body
      width="30%"
      :title="
        SeeLableDetails ? '查看类别标签的所有标签' : '查看商品标签的所有标签'
      "
      :visible.sync="LabelDetailsVisible"
      @close="LabelDetailsClose"
    >
      <el-form
        v-model="LabelDetails"
        size="mini"
        :label-position="labelPosition"
        label-width="80px"
      >
        <el-row :gutter="50">
          <el-col :span="16">
            <el-form-item :label="SeeLableDetails ? '类别标签' : '商品标签'">
              <el-input v-model="LabelDetails.title" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div style="width: 100%">
        <el-table
          height="300"
          ref="MagerTableStaff"
          class="table-styleDetail"
          border
          :row-class-name="tableRowClassName"
          :header-cell-style="{
            background: '#FCFBF2',
            color: '#6C6839',
            'text-align': 'center',
          }"
          :cell-style="{ 'text-align': 'center' }"
          :data="LabelDetails.array"
          tooltip-effect="dark"
          style="width: 100%"
        >
          <el-table-column width="50" type="index"> </el-table-column>
          <el-table-column
            prop="attrValue"
            :label="SeeLableDetails ? '类别' : '产品编码'"
          ></el-table-column>
          <el-table-column
            prop="attrName"
            label="类别描述"
            v-if="SeeLableDetails"
          >
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { UploadPictures } from "@/utils/constant";
import {
  productSelectProduct,
  couponsGroupOutappList,
  couponsGroupSelectCategory,
  couponsGroupSelectSelectLbl,
  importExcelProduct,
  couponsGroupSelectLblLine,
} from "@/api/couponsDepot.js";
import { GetShopQueryRegion } from "@/api/viewMemberModule.js";
export default {
  name: "SelectProduct",
  props: {
    WhetherSee: {
      //是否只是查看
      type: Boolean,
      default: false,
    },
    IsShow: {
      //是否禁用组件
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      switchData: false,
      labelPosition: "right",
      SeeLableDetails: true,
      LabelDetailsVisible: false,
      LabelDetails: {
        title: "",
        array: [],
      },

      SecuritiesUsablegoods: {
        CommodityCategory: "所有商品", //券可用于商品
        GoodsGenre: "",
        GenreType: "",
        GenreTypeRegion1: "",
        GenreTypeRegion2: "",
        GoodsType: "",
        GoodsTypeRegion1: "",
        GoodsTypeRegion2: "",
      },

      //选择商品标签数据
      GoodsLableVisible: false,
      GoodsLableFormhy: {
        search: "",
        pageNo: 1,
        pageSize: 50,
        pageTotal: 1,
        loading: true,
        GoodsLableData: [], //所有的商品数据
        SelectGoodsLableData: [], //选中的商品标签
      },

      //选择商品数据
      GoodsVisible: false,
      GoodsFormhy: {
        search: "",
        pageNo: 1,
        pageSize: 50,
        pageTotal: 1,
        loading: true,
        GoodsData: [], //所有的商品数据
        SelectGoodsData: [], //选中的商品标签
      },

      //选择类别标签数据
      CategoryLabelVisible: false,
      searchCategoryLabelFormhy: {
        search: "",
        pageNo: 1,
        pageSize: 50,
        pageTotal: 1,
        loading: true,
        CategoryLabelData: [], //所有的类别标签数据
        SelectCategoryLabelData: [], //选中的类别标签标签
      },

      //选择类别数据
      innerVisible: false,
      searchCategoryFormhy: {
        search: "",
        pageNo: 1,
        pageSize: 50,
        pageTotal: 1,
        loading: true,
        CategoryData: [], //所有的类别数据
        SelectCategoryData: [], //选中的类别
      },
      flag: 0,
      disable: false,
    };
  },
  watch: {
    GenreTypeS(val) {
      if (this.switchData) {
        if (val == "按类别筛选") {
          this.SecuritiesUsablegoods.GenreTypeRegion1 = "包含";
          this.SecuritiesUsablegoods.GenreTypeRegion2 = "";
        } else if (val == "按类别标签筛选") {
          this.SecuritiesUsablegoods.GenreTypeRegion1 = "";
          this.SecuritiesUsablegoods.GenreTypeRegion2 = "包含";
        } else {
          this.SecuritiesUsablegoods.GenreTypeRegion1 = "";
          this.SecuritiesUsablegoods.GenreTypeRegion2 = "";
        }
      }
    },
    CommodityCategoryS(val) {
      if (this.switchData) {
        if (val == "所有商品") {
          this.SecuritiesUsablegoods.GoodsGenre = "";
        } else if (val == "部分商品") {
          this.SecuritiesUsablegoods.GoodsGenre = "按类别";
        }
      }
    },
    GoodsTypeS(val) {
      if (this.switchData) {
        if (val == "按商品筛选") {
          this.SecuritiesUsablegoods.GoodsTypeRegion1 = "包含";
          this.SecuritiesUsablegoods.GoodsTypeRegion2 = "";
        } else if (val == "按商品标签筛选") {
          this.SecuritiesUsablegoods.GoodsTypeRegion1 = "";
          this.SecuritiesUsablegoods.GoodsTypeRegion2 = "包含";
        } else {
          this.SecuritiesUsablegoods.GoodsTypeRegion1 = "";
          this.SecuritiesUsablegoods.GoodsTypeRegion2 = "";
        }
      }
    },
  },
  computed: {
    //选择商品标签
    GoodsLabelIsMore() {
      return this.GoodsLableFormhy.pageNo >= this.GoodsLableFormhy.pageTotal;
    },
    GoodsLabelonLoading() {
      return this.GoodsLableFormhy.loading || this.GoodsLabelIsMore;
    },
    //选择商品
    GoodsIsMore() {
      return this.GoodsFormhy.pageNo >= this.GoodsFormhy.pageTotal;
    },
    GoodsonLoading() {
      return this.GoodsFormhy.loading || this.GoodsIsMore;
    },
    //选择类别标签
    categoryLabelIsMore() {
      return (
        this.searchCategoryLabelFormhy.pageNo >=
        this.searchCategoryLabelFormhy.pageTotal
      );
    },
    categoryLabelonLoading() {
      return this.searchCategoryLabelFormhy.loading || this.categoryLabelIsMore;
    },
    //选择类别
    categoryIsMore() {
      return (
        this.searchCategoryFormhy.pageNo >= this.searchCategoryFormhy.pageTotal
      );
    },
    categoryonLoading() {
      return this.searchCategoryFormhy.loading || this.categoryIsMore;
    },

    CommodityCategoryS() {
      return this.SecuritiesUsablegoods.CommodityCategory;
    },
    GenreTypeS() {
      return this.SecuritiesUsablegoods.GenreType;
    },
    GoodsTypeS() {
      return this.SecuritiesUsablegoods.GoodsType;
    },
  },
  created() {
    setTimeout(() => {
      //watch延迟1秒执行
      this.switchData = true;
    }, 1000);
  },
  methods: {
    parentHandleclick(e,disable) {
      this.flag = e;
      if (disable == 3) {
        this.disable = true;
      }
    },
    LabelDetailsClose() {
      //关闭弹框清空数据
      this.LabelDetails.title = "";
      this.LabelDetails.array = [];
    },
    SetdataPage(SecuritiesUsablegoods, array1, array2, array3, array4) {
      //设置初始值（查询,修改，复制情况下会调用）
      this.SecuritiesUsablegoods = SecuritiesUsablegoods;
      this.searchCategoryFormhy.SelectCategoryData = array1;
      this.searchCategoryLabelFormhy.SelectCategoryLabelData = array2;
      this.GoodsFormhy.SelectGoodsData = array3;
      this.GoodsLableFormhy.SelectGoodsLableData = array4;
    },
    renderTime(date) {
      //格式化时间
      if (date != null) {
        var dateee = new Date(date).toJSON();
        return new Date(+new Date(dateee) + 8 * 3600 * 1000)
          .toISOString()
          .replace(/T/g, " ")
          .replace(/\.[\d]{3}Z/, "");
      } else {
        return "";
      }
    },
    SelectCategoryLabel() {
      //点击选择类别标签按钮
      if (this.searchCategoryLabelFormhy.CategoryLabelData.length > 0) {
        this.CategoryLabelVisible = true;
        return false;
      }
      this.RcouponsGroupSelectSelectLbl();
    },
    RcouponsGroupSelectSelectLbl() {
      //获取全部类别标签数据
      let data = require("qs").stringify({
        pageNo: this.searchCategoryLabelFormhy.pageNo,
        search: this.searchCategoryLabelFormhy.search,
        pageSize: this.searchCategoryLabelFormhy.pageSize,
        lblKind: 0,
      });
      couponsGroupSelectSelectLbl(data).then((res) => {
        if (res.success) {
          this.searchCategoryLabelFormhy.pageTotal = res.data.pages;
          this.searchCategoryLabelFormhy.CategoryLabelData =
            this.searchCategoryLabelFormhy.CategoryLabelData.concat(
              res.data.list
            );
          this.searchCategoryLabelFormhy.loading = false;
        } else {
          this.$message.error(res.message);
        }
      });
      this.CategoryLabelVisible = true;
    },
    DetermineGoods() {
      //获取已选择的类别数据
      this.GoodsFormhy.SelectGoodsData =
        this.GoodsFormhy.SelectGoodsData.concat(
          ...this.$refs.GoodsRefsTable.selection
        );
      // 去重
      const res = new Map();
      this.GoodsFormhy.SelectGoodsData =
        this.GoodsFormhy.SelectGoodsData.filter(
          (a) => !res.has(a.ProductCode) && res.set(a.ProductCode, 1)
        );
      this.$refs.GoodsRefsTable.clearSelection();
      this.GoodsVisible = false;
    },
    DetermineGoodsLabel() {
      //获取已选择的商品标签数据
      this.GoodsLableFormhy.SelectGoodsLableData =
        this.GoodsLableFormhy.SelectGoodsLableData.concat(
          ...this.$refs.GoodsLabelTable.selection
        );
      // 去重
      const res = new Map();
      this.GoodsLableFormhy.SelectGoodsLableData =
        this.GoodsLableFormhy.SelectGoodsLableData.filter(
          (a) => !res.has(a.lblID) && res.set(a.lblID, 1)
        );
      this.$refs.GoodsLabelTable.clearSelection();
      this.GoodsLableVisible = false;
    },
    DetermineCategoryLabel() {
      //获取已选择的类别标签数据
      this.searchCategoryLabelFormhy.SelectCategoryLabelData =
        this.searchCategoryLabelFormhy.SelectCategoryLabelData.concat(
          ...this.$refs.CategoryLabelTable.selection
        );
      // 去重
      const res = new Map();
      this.searchCategoryLabelFormhy.SelectCategoryLabelData =
        this.searchCategoryLabelFormhy.SelectCategoryLabelData.filter(
          (a) => !res.has(a.lblID) && res.set(a.lblID, 1)
        );
      this.$refs.CategoryLabelTable.clearSelection();
      this.CategoryLabelVisible = false;
    },
    ImportGoods1() {
      this.$message({
        type: "info",
        message: "请先选择按商品筛选,再进行导入!",
      });
    },
    ImportCategory1() {
      this.$message({
        type: "info",
        message: "请先选择按类别筛选,再进行导入!",
      });
    },
    //导入商品
    ImportGoods(file) {
      let formData = new FormData();
      formData.append("file", file.raw);
      formData.append("type", "Product");
      importExcelProduct(formData).then((res) => {
        if (res.success) {
          this.$message.success("导入成功");
          if (res.data.length > 0) {
            res.data.forEach((item) => {
              item.ProductName_CN = item.name;
              item.ProductCode = item.productCode;
            });
            this.GoodsFormhy.SelectGoodsData =
              this.GoodsFormhy.SelectGoodsData.concat(...res.data);
            // 去重
            const res1 = new Map();
            this.GoodsFormhy.SelectGoodsData =
              this.GoodsFormhy.SelectGoodsData.filter(
                (a) => !res1.has(a.ProductCode) && res1.set(a.ProductCode, 1)
              );
          }
          this.$refs.UploadImport.clearFiles();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //导入类别
    ImportCategory(file) {
      let formData = new FormData();
      formData.append("file", file.raw);
      formData.append("type", "Category");
      importExcelProduct(formData).then((res) => {
        if (res.success) {
          this.$message.success("导入成功");
          if (res.data.length > 0) {
            res.data.forEach((item) => {
              item.categoryCn = item.name;
            });
            this.searchCategoryFormhy.SelectCategoryData =
              this.searchCategoryFormhy.SelectCategoryData.concat(...res.data);
            // 去重
            const res1 = new Map();
            this.searchCategoryFormhy.SelectCategoryData =
              this.searchCategoryFormhy.SelectCategoryData.filter(
                (a) => !res1.has(a.categoryID) && res1.set(a.categoryID, 1)
              );
          }
          this.$refs.UploadImport.clearFiles();
        } else {
          this.$message.error(res.message);
        }
      });
    },
    //选择商品标签数据
    resetSelectGoodsLableData() {
      //清空已选择的商品
      if (this.GoodsLableFormhy.SelectGoodsLableData.length <= 0) {
        return false;
      }
      this.$confirm("此操作将删除已选择的商品标签数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.GoodsLableFormhy.SelectGoodsLableData = [];
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    resetSelectGoodsData() {
      //清空已选择的商品
      if (this.GoodsFormhy.SelectGoodsData.length <= 0) {
        return false;
      }
      this.$confirm("此操作将删除已选择的商品数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.GoodsFormhy.SelectGoodsData = [];
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    resetSelectCategoryLabelData() {
      //清空已选择的类别标签
      if (this.searchCategoryLabelFormhy.SelectCategoryLabelData.length <= 0) {
        return false;
      }
      this.$confirm("此操作将删除已选择的类别标签数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.searchCategoryLabelFormhy.SelectCategoryLabelData = [];
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    resetSelectCategoryData() {
      //清空已选择的类别
      if (this.searchCategoryFormhy.SelectCategoryData.length <= 0) {
        return false;
      }
      this.$confirm("此操作将删除已选择的类别数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.searchCategoryFormhy.SelectCategoryData = [];
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    GoodsTouchTheBottom() {
      //选择商品弹框触底刷新
      this.GoodsFormhy.loading = true;
      this.GoodsFormhy.pageNo++;
      this.RproductSelectProduct();
    },
    GoodsLabelTouchTheBottom() {
      //选择商品标签弹框触底刷新
      this.GoodsLableFormhy.loading = true;
      this.GoodsLableFormhy.pageNo++;
      this.RproductSelect();
    },
    categoryLabelTouchTheBottom() {
      //选择类别标签弹框触底刷新
      this.searchCategoryLabelFormhy.loading = true;
      this.searchCategoryLabelFormhy.pageNo++;
      this.RcouponsGroupSelectSelectLbl();
    },
    categoryonTouchTheBottom() {
      //选择类别弹框触底刷新
      this.searchCategoryFormhy.loading = true;
      this.searchCategoryFormhy.pageNo++;
      this.RcouponsGroupSelectCategory();
    },
    RproductSelect() {
      //获取商品标签数据
      //获取全部类别标签数据
      let data = require("qs").stringify({
        pageNo: this.GoodsLableFormhy.pageNo,
        search: this.GoodsLableFormhy.search,
        pageSize: this.GoodsLableFormhy.pageSize,
        lblKind: 1,
      });
      couponsGroupSelectSelectLbl(data).then((res) => {
        if (res.success) {
          this.GoodsLableFormhy.pageTotal = res.data.pages;
          this.GoodsLableFormhy.GoodsLableData =
            this.GoodsLableFormhy.GoodsLableData.concat(res.data.list);
          this.GoodsLableFormhy.loading = false;
        } else {
          this.$message.error(res.message);
        }
      });
      this.GoodsLableVisible = true;
    },
    RproductSelectProduct() {
      //获取商品数据
      let data = require("qs").stringify({
        pageNo: this.GoodsFormhy.pageNo,
        search: this.GoodsFormhy.search,
        pageSize: this.GoodsFormhy.pageSize,
      });
      productSelectProduct(data).then((res) => {
        if (res.success) {
          this.GoodsFormhy.pageTotal = res.data.pages;
          this.GoodsFormhy.GoodsData = this.GoodsFormhy.GoodsData.concat(
            res.data.list
          );
          this.GoodsFormhy.loading = false;
        } else {
          this.$message.error(res.message);
        }
      });
      this.GoodsVisible = true;
    },
    RcouponsGroupSelectCategory() {
      //获取类别数据
      let data = require("qs").stringify({
        pageNo: this.searchCategoryFormhy.pageNo,
        search: this.searchCategoryFormhy.search,
        pageSize: this.searchCategoryFormhy.pageSize,
      });
      couponsGroupSelectCategory(data).then((res) => {
        if (res.success) {
          this.searchCategoryFormhy.pageTotal = res.data.pages;
          this.searchCategoryFormhy.CategoryData =
            this.searchCategoryFormhy.CategoryData.concat(res.data.list);
          this.searchCategoryFormhy.loading = false;
        } else {
          this.$message.error(res.message);
        }
      });
      this.innerVisible = true;
    },
    SelectGoodsLable() {
      //选择商品标签数据
      //点击选择标签商品按钮
      if (this.GoodsLableFormhy.GoodsLableData.length > 0) {
        this.GoodsLableVisible = true;
        return false;
      }
      this.RproductSelect();
    },
    SelectGoods() {
      //选择商品数据
      //点击选择商品按钮
      if (this.GoodsFormhy.GoodsData.length > 0) {
        this.GoodsVisible = true;
        return false;
      }
      this.RproductSelectProduct();
    },
    SelectCategory() {
      //点击选择类别按钮
      if (this.searchCategoryFormhy.CategoryData.length > 0) {
        this.innerVisible = true;
        return false;
      }
      this.RcouponsGroupSelectCategory();
    },
    Selectedvaluetransfer() {
      //获取已选择的类别数据
      this.searchCategoryFormhy.SelectCategoryData =
        this.searchCategoryFormhy.SelectCategoryData.concat(
          ...this.$refs.CategoryTable1.selection
        );
      // 去重
      const res = new Map();
      this.searchCategoryFormhy.SelectCategoryData =
        this.searchCategoryFormhy.SelectCategoryData.filter(
          (a) => !res.has(a.categoryID) && res.set(a.categoryID, 1)
        );

      this.$refs.CategoryTable1.clearSelection();
      this.innerVisible = false;
    },
    SearchGoods() {
      //商品查询
      this.GoodsFormhy.pageNo == 1;
      this.GoodsFormhy.loading = true;
      this.GoodsFormhy.GoodsData = [];
      this.RproductSelectProduct();
    },
    GoodsSearchhyLabel() {
      //商品标签查询
      this.GoodsLableFormhy.pageNo == 1;
      this.GoodsLableFormhy.loading = true;
      this.GoodsLableFormhy.GoodsLableData = [];
      this.RproductSelect();
    },
    categorySearchhyLabel() {
      //类别标签查询
      this.searchCategoryLabelFormhy.pageNo == 1;
      this.searchCategoryLabelFormhy.loading = true;
      this.searchCategoryLabelFormhy.CategoryLabelData = [];
      this.RcouponsGroupSelectSelectLbl();
    },
    categorySearchhy() {
      //类别查询
      this.searchCategoryFormhy.pageNo == 1;
      this.searchCategoryFormhy.loading = true;
      this.searchCategoryFormhy.CategoryData = [];
      this.RcouponsGroupSelectCategory();
    },
    // 判断如果是单行就变黄色双行是白色
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
    GoodsModuleDownload() {
      //下载模板
      const ele = document.createElement("a");
      ele.style.display = "none";
      ele.href = `${UploadPictures}/api/templates/券库产品编码导入模板.xlsx`;
      ele.download = "";
      document.querySelectorAll("body")[0].appendChild(ele);
      ele.click();
      ele.remove();
    },
    CategoryModuleDownload() {
      //下载模板
      const ele = document.createElement("a");
      ele.style.display = "none";
      ele.href = `${UploadPictures}/api/templates/券库类别导入模板.xlsx`;
      ele.download = "";
      document.querySelectorAll("body")[0].appendChild(ele);
      ele.click();
      ele.remove();
    },
    DeleteGoods(row) {
      //删除商品
      this.GoodsFormhy.SelectGoodsData.forEach((item, index) => {
        if (item.ProductCode == row.ProductCode) {
          this.GoodsFormhy.SelectGoodsData.splice(index, 1);
        }
      });
    },
    DeleteGoodsLable(row) {
      //删除类别标签
      this.GoodsLableFormhy.SelectGoodsLableData.forEach((item, index) => {
        if (item.lblID == row.lblID) {
          this.GoodsLableFormhy.SelectGoodsLableData.splice(index, 1);
        }
      });
    },
    DeleteCategoryLable(row) {
      //删除类别标签
      this.searchCategoryLabelFormhy.SelectCategoryLabelData.forEach(
        (item, index) => {
          if (item.lblID == row.lblID) {
            this.searchCategoryLabelFormhy.SelectCategoryLabelData.splice(
              index,
              1
            );
          }
        }
      );
    },
    DeleteCategory(row) {
      //删除类别
      this.searchCategoryFormhy.SelectCategoryData.forEach((item, index) => {
        if (item.categoryID == row.categoryID) {
          this.searchCategoryFormhy.SelectCategoryData.splice(index, 1);
        }
      });
    },
    OnclickConponesName(row, type) {
      this.LabelDetailsVisible = true;
      this.SeeLableDetails = type;
      let data = require("qs").stringify({
        lblID: row.lblID,
      });
      couponsGroupSelectLblLine(data).then((res) => {
        if (res.success) {
          this.LabelDetails.title = row.lblName;
          this.LabelDetails.array = res.data;
        } else {
          this.$message({
            message: res.message,
            type: "warning",
          });
        }
      });
    },
    RGetShopQueryRegion() {
      //获取区域和门店
      GetShopQueryRegion().then((res) => {
        let arr1 = [],
          arr2 = [];
        if (res.success) {
          res.data.forEach((item) => {
            if (item.chlidren.length > 0) this.StoredataArray.push(item);
          });
          this.StoredataArray.forEach((item, index) => {
            this.StoreSelectLength += 1;
            if (index % 2 == 0) {
              arr1.push(item);
            } else {
              arr2.push(item);
            }
          });
          this.StoreSelectionList = arr1.map((key, value) => [
            key,
            arr2[value],
          ]);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    RcouponsGroupOutappList() {
      //获取业务数据
      couponsGroupOutappList().then((res) => {
        if (res.success) {
          res.data.forEach((item) => {
            item.IsCheck = false;
          });
          this.BasicData.systemBusiness = res.data;
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/.table-styleDetail {
  .el-table-column--selection.is-leaf .el-checkbox {
    display: none;
  }
}
.elUpload {
  box-sizing: border-box;
  border: none;
  display: flex;
  justify-content: center;
  width: 98px;
  height: 34px;
}
.buttom-flex {
  display: flex;
  flex-direction: row;
}
.ConponesName {
  text-decoration: underline;
  color: #a19b59;
}
.ConponesName:hover {
  cursor: pointer;
}
.margig-left80 {
  margin-left: 80px !important;
}
.formClass {
  margin-top: 10px;
}
.SelectArea {
  display: flex;
  margin-top: 8px;
  width: 140px;
}
.CategoryFiltering-div-top {
  display: flex;
  align-content: center;
  justify-content: space-between;
}
.CategoryFiltering-div {
  margin-left: 20px;
  display: flex;
  flex-direction: column;
  width: 500px;
  height: 100%;
}
.CategoryFiltering-conter {
  // border: 1px solid #a8a8a8;
  display: flex;
  height: 100%;
  margin-top: -15px;
}
.CategoryFiltering {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 700px;
  margin-top: 20px;
}
.right-top {
  display: flex;
  flex-direction: column;
  height: 430px;
}
.right-buttom {
  display: flex;
  flex-direction: column;
  height: 430px;
  margin-top: 20px;
}
.part-class-right {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.part-class-left {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 80px;
  height: 470px;
}
.Coupons-part {
  display: flex;
  flex-direction: row;
  height: 100%;
  margin-left: 50px;
}
.Conpone-flex {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: 10px;
  height: 50px;
}
.MaturityOfSecurities {
  display: flex;
}
.periodOfValidity {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.form-div {
  padding: 20px 0px;
  padding-left: 100px;
}
.textareaClass {
  resize: none;
  width: 100%;
}
.textareaClass-store {
  padding: 2px 10px;
}
#cashcreation {
  margin-bottom: 100px;
}
.push-button {
  width: 100px;
  background-color: #e9e7d3;
}
.buttom-div {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 250px;
  align-content: center;
}
.header-text {
  margin-bottom: 5px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: 50px;
  margin-top: 20px;
  color: #76734f;
}
.biaoti {
  height: 30px;
  line-height: 30px;
  font-size: 16px;
  padding-left: 50px;
  background-color: #e3e3e3;
}
::v-deep {
  .el-card__body {
    padding: 20px 0 20px 0;
  }
  // 选择门店弹框样式
  .outlet {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }
    .el-dialog__body {
      padding: 20px 10px 20px 10px;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }
    .el-button:hover {
      background-color: #b5b386;
      color: #f2f2f2;
    }
  }
}
</style>
